import React, { Component } from 'react';
import { Input, Button, Alert, Form, FormGroup } from 'reactstrap';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import { LoginContainer, MPaper } from './styles';
import { formatError } from '../../utils';
import { LoginQuery } from './Logingql';

const LoginMutation = graphql(LoginQuery, { name: 'login' });

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      error: '',
    };
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onsubmit = async e => {
    e.preventDefault();
    // check if the parameter are empty
    if (this.state.username.length < 4) {
      this.setState({ error: 'The email addrss is required' });
      return;
    }
    if (this.state.password.length < 3) {
      this.setState({ error: 'The password is required' });
      return;
    }
    const { login, history } = this.props;
    try {
      const result = await login({
        variables: {
          username: this.state.username,
          password: this.state.password,
        },
      });
      // sessionStorage.setItem('xtoken', result.data.authenticate.token);
      sessionStorage.setItem('userdata', JSON.stringify(result.data.login));
      history.push('/dashboard');
    } catch (error) {
      this.setState({
        error: formatError(error),
      });
    }
  };

  render() {
    return (
      <div>
        <LoginContainer>
          <MPaper>
            {this.state.error && (
              <Alert color="danger">{this.state.error}</Alert>
            )}
            <Form>
              <FormGroup>
                <Input
                  name="username"
                  placeholder="E-mail"
                  value={this.state.username}
                  onChange={e => this.onChange(e)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  name="password"
                  placeholder="Password"
                  type="password"
                  value={this.state.password}
                  onChange={e => this.onChange(e)}
                  required
                />
              </FormGroup>
              <div style={{ float: 'right' }}>
                <Button color="primary" onClick={e => this.onsubmit(e)}>
                  Login
                </Button>
              </div>
            </Form>
            <br />
          </MPaper>
          <div style={{ textAlign: 'center', paddingBottom: '15px' }}>
            <Link to="/documentation" target="_blank">View the API Documentation</Link>
          </div>
        </LoginContainer>
      </div>
    );
  }
}

export default LoginMutation(Login);



// WEBPACK FOOTER //
// ./src/views/Login/Login.js